import React from 'react';
import { Card } from 'react-bootstrap';

export const BaseCard = ({ title, text, children, ...props }) => (
  <Card className="base-card" {...props}>
    <Card.Title>{title}</Card.Title>
    <Card.Body>
      {children}
    </Card.Body>
  </Card>
);
